// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__36KIh","label":"Category_label__18-1T","content":"Category_content__3J_QF","header":"Category_header__2opG2","location":"Category_location__iXj6E"};